import { AxiosError } from "axios";
import { api } from "../../api/api";
import SimularAntecipacaoRequest from "../../model/antecipacao/SimularAntecipacaoRequest";
import SimulacaoAntecipacaoSiengeResponse from "../../model/sienge/antecipacaoParcela/SimulacaoAntecipacaoSiengeResponse";
import AnteciparParcelasRequest from "../../model/antecipacao/AnteciparParcelasRequest";
import SolicitarAntecipacaoRequest from "../../model/antecipacao/SolicitarAntecipacaoRequest";

export default class AntecipacaoParcelaService {
    antecipar(dados: AnteciparParcelasRequest) {
        return new Promise<void>((resolve, reject): void => {
            let url = `/antecipacao/antecipar`;
            api
                .post(url, dados)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    solicitarAntecipacao(dados: SolicitarAntecipacaoRequest) {
        return new Promise<void>((resolve, reject): void => {
            let url = `/antecipacao/solicitar`;
            api
                .post(url, dados)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    simular(dados: SimularAntecipacaoRequest) {
        return new Promise<SimulacaoAntecipacaoSiengeResponse>((resolve, reject): void => {
            let url = `/antecipacao/simular`;
            api
                .post(url, dados)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}